import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Tooltip from '@material-ui/core/Tooltip';
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function Unidade() {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [comboPre, setComboPre] = useState([{ value: '', display: '' }])
  const [comboAnd, setComboAnd] = useState([{ value: '', display: '' }])
  const [comboSto, setComboSto] = useState([{ value: '', display: '' }])
  const [comboAla, setComboAla] = useState([{ value: '', display: '' }])
  const [comboAco, setComboAco] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: '', display: '' }])
  const [blockCombos, setBlockCombos] = useState(true)

  const [enableEdit, setEnableEdit] = useState('N')

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Unidades', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Unidades', 'Inclusao'))
      }

      setComboPre(await api.getComboData('predio'))
      setComboAco(await api.getComboData('acomodacao'))
      setComboAtivo([
        {
          "value": "S",
          "display": "Ativo",
        },
        {
          "value": "N",
          "display": "Inativo",
        },])


      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/unidade?pk_und=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
      'fk_pre',
      'fk_and',
      'fk_aco',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr === 'fk_pre') fieldName = 'Prédio'
      if (curr === 'fk_and') fieldName = 'Andar'
      if (curr === 'fk_aco') fieldName = 'Acomodação'

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  useEffect(() => {
    const fetchCombos = async () => {
      if (data.fk_pre > 0) {
        setComboAnd(await api.getComboData('andar', data.fk_pre))
        setComboSto(await api.getComboData('setor', data.fk_pre))
        setComboAla(await api.getComboData('ala', data.fk_pre))

        setBlockCombos(false)
      } else setBlockCombos(true)
    }

    fetchCombos()
  }, [data.fk_pre])



  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)

        if (data.descricao) {
          await api.get('/unidade?descricao=' + data.descricao + '&und=' + data.pk_und).then(r => {
            if (r.data.length > 0)
              errors.push(' Já existe unidade com essa descrição!')
          })
        }

        if (errors.length === 0) {
          if (updateType) {
            api.post('/unidade/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/unidade/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'CNPJ':
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Unidade</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='45'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#528b46"
            label="Descrição"
            variant="outlined"
            size="small"
            required
            style={{ width: 400 }}
          />
          <br />
          <FrSelect
            value={data.fk_pre || ''}
            onChange={handleChange}
            name="fk_pre"
            id="fk_pre"
            label='Prédio'
            data={comboPre}
            style={{ width: 200 }}
          />

          <Tooltip title={blockCombos ? 'Informe um prédio antes de informar o andar!' : ''}>
            <FrSelect
              value={data.fk_and || ''}
              onChange={handleChange}
              name="fk_and"
              id="fk_and"
              label='Andar'
              data={comboAnd}
              style={{ width: 200 }}
              disabled={blockCombos}
            />
          </Tooltip>


          <Tooltip title={blockCombos ? 'Informe um prédio antes de informar o setor!' : ''}>
            <FrSelect
              value={data.fk_sto || ''}
              onChange={handleChange}
              name="fk_sto"
              id="fk_sto"
              label='Setor'
              data={comboSto}
              style={{ width: 200 }}
              disabled={blockCombos}

            />
          </Tooltip>

          <Tooltip title={blockCombos ? 'Informe um prédio antes de informar a ala!' : ''}>
            <FrSelect
              value={data.fk_ala || ''}
              onChange={handleChange}
              name="fk_ala"
              id="fk_ala"
              label='Ala'
              data={comboAla}
              style={{ width: 200 }}
              disabled={blockCombos}
            />
          </Tooltip>

          <br />
          <FrSelect
            value={data.fk_aco || ''}
            onChange={handleChange}
            name="fk_aco"
            id="fk_aco"
            label='Acomodação'
            data={comboAco}
            style={{ width: 300 }}
          />

          <FrSelect
            value={data.ativo || ''}
            onChange={handleChange}
            name="ativo"
            id="ativo"
            label='Ativo'
            data={comboAtivo}
            style={{ width: 100 }}
          />
          <br />
          <br />
          <FrTextInput
            maxLength="500"
            value={data.detalhamento || ""}
            onChange={handleChange}
            name="detalhamento"
            id="detalhamento"
            color="#528b46"
            label="Detalhamento"
            variant="filled"
            size="small"
            required
            style={{ width: 500 }}
            multiline
            rows="8"
            rowsMax="8"
            fullWidth
          />


        </form>
        <div className="regButtonsDiv">
          {(enableEdit === 'S') ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{(enableEdit === 'S') ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Unidade;
